import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    '& div': {
      width: 50,
      '&:first-child': {
        height: 44,
      },
      '&:last-child': {
        height: 30,
      },
    },
  },
  logo: {
    width: '12vmin',
  },
  logoInner: {
    width: 50,
    height: 80,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  description: {
    marginLeft: 5,
    width: '12vmin',
  },
}))
